// extracted by mini-css-extract-plugin
module.exports = {"container":"e_vlb","styleWarning":"e_wlb"};